"use strict";

let ExpandBox = require("app/shared/components/ExpandBox/expand-box");
let ExportOrganizationsButton = require("app/screens/Organizations/components/ExportOrganizationsButton/export-organizations-button");
let ExportPeopleButton = require("app/screens/People/components/ExportPeopleButton/export-people-button");
let ExportDealsButton = require("app/screens/Deals/components/ExportDealsButton/export-deals-button");
let ExportActivitiesButton = require("app/screens/Activity/components/ExportActivitiesButton/export-activities-button");
let cx = require("classnames");

let ExportAccountData = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    skipOptions: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      skipOptions: true
    }
  },
  getInitialState: function() {
    return {
      expanded: false
    };
  },
  expandBox: function() {
    this.setState({ expanded: !this.state.expanded });
  },
  render: function() {
    let buttonClasses = cx({
      "expandBox-icon": true,
      "tr-180": this.state.expanded
    });

    return <div className="mb-10">
      <ExpandBox title="Exportar dados da conta"
                  onClick={this.expandBox}
                  expanded={this.state.expanded}
                  boxHeight={260}>
        <div className="expandBox-body lh-initial p-0">
          <div className="panel-group">
            <ExportOrganizationsButton {...this.props} />
          </div>
          <div className="panel-group">
            <ExportPeopleButton {...this.props} />
          </div>
          <div className="panel-group">
            <ExportDealsButton {...this.props} />
          </div>
          <div className="panel-group">
            <ExportActivitiesButton {...this.props} />
          </div>
        </div>
      </ExpandBox>
    </div>;
  }
});

module.exports = ExportAccountData;



// WEBPACK FOOTER //
// ./app/shared/components/ExportButton/export-account-data.jsx